import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { toast } from 'react-toastify';

import { getEntity } from '../../../services/entity/entity-service';

import { buildActivityCard } from '../../../services/activity/activity-service';
import { getPlayer } from '../../../services/player/player-service';
import {
  buildGameOptions,
  buildGameSession,
  playActiveSession,
} from '../../../services/game-session/game-session-service';

import PlayerGameSessionCard from '../../components/player-game-session-card/player-game-session-card';
import FormSection from '../../components/form-section/form-section';
import PlayerDashboardButtons from '../../components/player-dashboard-buttons/player-dashboard-buttons';
import Result from '../../components/results/result';
import { setPageTitle } from '../../../modules/application/pages';
import { getPlayerGameSessionResults } from '../../../modules/player_game_session_api';
import { getPlayerGameSession, updatePlayerGameSession } from '../../../modules/player_game_session';
import { getPlayerGameSessionActivities } from '../../../modules/player_game_session_activity';
import { getPlayerGameSessionResultsAsync } from '../../../modules/result_api';

import './player-game-session.css';

class PlayerGameSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      player: {},
      playerGameSession: {},
    };

    this.setPlayer = this.setPlayer.bind(this);
    this.onClickSaveNotes = this.onClickSaveNotes.bind(this);
    this.onClickPlayActiveSession = playActiveSession.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { id, player_game_session_id } = this.props.match.params;
    const _id = id && parseInt(id, 10);
    const _player_game_session_id = player_game_session_id && parseInt(player_game_session_id, 10);

    if (_id !== this.state.player.id) {
      this.props.dispatch(getPlayerGameSessionResults(_player_game_session_id));
      this.setPlayer(_id, _player_game_session_id);
    }
  }

  async setPlayer(playerId, playerGameSessionId) {
    const { dispatch } = this.props;

    const player = await getPlayer(playerId, this.props);
    const gameOptions = await buildGameOptions(this.props);

    const playerGameSession = await getEntity(dispatch, getPlayerGameSession(playerGameSessionId));

    const gameSession = await buildGameSession(dispatch, null, playerGameSession.game_session, gameOptions);
    playerGameSession._gameSession = gameSession;

    const playerGameSessionActivities = await getEntity(
      dispatch,
      getPlayerGameSessionActivities([{ player: player.id }]),
      true
    );

    const gameSessionResults = await getPlayerGameSessionResultsAsync(playerGameSession.id);

    const results = gameSessionResults.data.results;
    const activities = playerGameSessionActivities.filter((activity) =>
      playerGameSession.activities.includes(activity.id)
    );

    activities.forEach((activity) => {
      activity._result = results.find((result) => activity.results.length > 0 && activity.results[0] === result.id);
    });

    const activityCards = activities.map((activity) =>
      buildActivityCard(activity, gameOptions, true, null, null, null, null, true)
    );

    playerGameSession._activities = activities;
    playerGameSession._activityCards = activityCards;

    playerGameSession._resultCards = activities.map((activity) => buildActivityCard(activity, gameOptions, true));

    this.setState({ player, gameSession, playerGameSession, gameOptions });

    dispatch(setPageTitle(player.name));
  }

  render() {
    return (
      <div className="px-1">
        <FormSection component={this.playerGameSession()} />
      </div>
    );
  }

  playerGameSession() {
    const { isTherapistRole, user, currentUserId } = this.props;
    const { player, playerGameSession } = this.state;
    const playerGameSessionResults = this.props.player_game_session.current_game_session_results;

    return (
      <div className="mp-0 container-fluid">
        <PlayerDashboardButtons player={player} activePage="back" isTherapistRole={isTherapistRole} />
        {playerGameSession && (
          <Col className="mp-0 text-left">
            <PlayerGameSessionCard
              playerGameSession={playerGameSession}
              user={user}
              player={player}
              isEdit
              isActivities
              onClickSaveNotes={this.onClickSaveNotes}
              onClickPlayActiveSession={() => {
                this.onClickPlayActiveSession(player, currentUserId, null, playerGameSession._gameSession);
              }}
            />
            <Row className="mp-0 text-center">
              {playerGameSessionResults &&
                playerGameSessionResults.map((result) => (
                  <Col className="mx-2 p-0">
                    <Result key={result.id} result={result} current_user={user} />
                  </Col>
                ))}
              {!playerGameSessionResults && <h6 className="ml-2 py-2 text-secondary">No Results Available</h6>}
            </Row>
          </Col>
        )}
      </div>
    );
  }

  async onClickSaveNotes(notes) {
    const { playerGameSession } = this.state;
    await getEntity(this.props.dispatch, updatePlayerGameSession(playerGameSession.id, { notes }));
    playerGameSession.notes = notes;

    toast.success('Session Notes updated!', { position: toast.POSITION.TOP_CENTER });

    this.setState({ playerGameSession });
  }
}

const withState = connect((state) => {
  const { player_game_session, user } = state;

  return {
    currentUserId: user.currentUserId,
    player_game_session: player_game_session,
    user: user,
    isTherapistRole: user.isTherapistRole,
  };
});

export default withRouter(withState(PlayerGameSession));
